export function isNumber(o?: any): o is number {
    return typeof o === 'number';
}